"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyField = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_text_field_1 = require("@hopin-team/ui-text-field");

var react_1 = tslib_1.__importStar(require("react"));

var CopyField = function CopyField(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      className = _a.className,
      _b = _a.copiedText,
      copiedText = _b === void 0 ? 'Copied!' : _b,
      _c = _a.copyText,
      copyText = _c === void 0 ? 'Copy' : _c,
      id = _a.id,
      isInverse = _a.isInverse,
      label = _a.label,
      hideLabel = _a.hideLabel,
      name = _a.name,
      size = _a.size,
      value = _a.value,
      _d = _a.type,
      type = _d === void 0 ? 'button' : _d;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'CopyField',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _e = tslib_1.__read((0, react_1.useState)(copyText), 2),
      buttonText = _e[0],
      setButtonText = _e[1];

  var _f = tslib_1.__read((0, react_1.useState)(false), 2),
      isDisabled = _f[0],
      setIsDisabled = _f[1];

  var inputRef = (0, react_1.useRef)(null);

  var handleAfterClick = function handleAfterClick() {
    setIsDisabled(true);
    setTimeout(function () {
      setIsDisabled(false);
      setButtonText(copyText);
    }, 5000);
  };

  var onCopyToClipboard = function onCopyToClipboard() {
    if (inputRef.current) {
      var text = inputRef.current.value;
      navigator.clipboard.writeText(text);
      setButtonText(copiedText);
      handleAfterClick();
    }
  };

  var buttonProps = {};

  if (type === 'button') {
    buttonProps['button'] = react_1.default.createElement(ui_button_1.Button, {
      disabled: isDisabled,
      onClick: onCopyToClipboard,
      size: size === 'small' ? 'tiny' : 'small',
      pattern: isInverse ? 'inverse' : 'secondary',
      isOutlined: true
    }, buttonText);
  } else {
    buttonProps['butticon'] = react_1.default.createElement(ui_butticon_1.Butticon, {
      icon: "copy",
      title: buttonText,
      disabled: isDisabled,
      onClick: onCopyToClipboard,
      size: size === 'small' ? 'tiny' : 'small',
      pattern: isInverse ? 'inverse' : 'secondary'
    });
  }

  return react_1.default.createElement(ui_text_field_1.TextField, tslib_1.__assign({
    className: rootClasses,
    "data-testid": testID,
    id: id,
    type: "text",
    ref: inputRef,
    value: value,
    name: name,
    isReadOnly: true,
    size: size,
    label: label,
    hideLabel: hideLabel,
    isInverse: isInverse
  }, buttonProps));
};

var CopyFieldWithSpace = (0, ui_helper_with_space_1.withSpace)(CopyField);
exports.CopyField = CopyFieldWithSpace;